import styled from 'styled-components';

const IdentifierTableData = styled.td`
  max-width: 10rem;
  white-space: nowrap;
  font-family: 'Courier Prime';
`;

export default IdentifierTableData;
